import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_URL = import.meta.env.VITE_SITE_URL || 'https://peternity.io';
const LOCALES = [
  { code: 'en', prefix: '' },
  { code: 'ru', prefix: '/ru' },
  { code: 'es', prefix: '/es' },
];

export function useHreflang() {
  const location = useLocation();

  useEffect(() => {
    // Remove old hreflang tags
    document.querySelectorAll('link[hreflang]').forEach(el => el.remove());
    // Remove old canonical
    document.querySelector('link[rel="canonical"]')?.remove();

    const cleanPath = location.pathname.replace(/^\/(ru|es)/, '') || '/';

    // Add hreflang for each locale
    LOCALES.forEach(({ code, prefix }) => {
      const link = document.createElement('link');
      link.rel = 'alternate';
      link.hreflang = code;
      link.href = `${BASE_URL}${prefix}${cleanPath === '/' ? '/' : cleanPath}`;
      document.head.appendChild(link);
    });

    // x-default
    const xDefault = document.createElement('link');
    xDefault.rel = 'alternate';
    xDefault.hreflang = 'x-default';
    xDefault.href = `${BASE_URL}${cleanPath === '/' ? '/' : cleanPath}`;
    document.head.appendChild(xDefault);

    // Canonical (points to current locale page)
    const currentPrefix = LOCALES.find(l =>
      location.pathname.startsWith(`/${l.code}`) && l.code !== 'en'
    )?.prefix ?? '';
    const canonical = document.createElement('link');
    canonical.rel = 'canonical';
    canonical.href = `${BASE_URL}${currentPrefix}${cleanPath === '/' ? '/' : cleanPath}`;
    document.head.appendChild(canonical);
  }, [location.pathname]);
}
